// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"0ce7e5a4","239":"8edd0465","872":"9d90d3d1"}[chunkId] + ".chunk.js";
};